import React, {useContext} from 'react';
import {FormattedDate, FormattedMessage} from "react-intl";

// Material UI
import {TableBody, TableCell, TableHead, Tabs} from "@mui/material";

// Components
import Page from "components/WMS/Desktop/Page";
import Pagination from "components/WMS/List/Pagination";

import SearchBar from "components/List/components/SearchBar";
import Tab from "components/translator/Tab";
import TableRowHead from "components/WMS/List/TableRowHead";
import TableCellHead from "components/WMS/List/TableCellHead";
import TableRow from "components/WMS/List/TableRow";
import Table from "components/WMS/List/Table";

// Local Components
import TrackingNumber from "../../components/TrackingNumber";
import CustomerName from "../../components/CustomerName";
import CustomerContact from "../../components/CustomerContact";
import WmsDesktopLayout from "../../../wmsDesktopLayout";
import ActionLink from "../../components/ActionLink";
import Containers from "../../components/Containers";

// Context
import {ClickAndCollectHandOverContext} from "../context/ClickAndCollectHandOverContext";

// Assets
import {blueColor} from "assets/jss/main";

function DesktopView(props) {
    const {
        title,
        subtitle,
        shipments,
        setSelectedShipment,
        setSearchString,
        containers,
        selectedContainer,
        setSelectedContainer,
        onPageChange,
        getShipments,
        nextLink,
        previousLink,
        totalPages,
        sort,
        handleRequestSort,
        setOpenHandOverScanShipmentPopup
    } = useContext(ClickAndCollectHandOverContext);

    return (
        <WmsDesktopLayout>
            <WmsDesktopLayout.SideBar>
            </WmsDesktopLayout.SideBar>
            <WmsDesktopLayout.Content>
                <Page>
                    <Page.HeaderLeft>
                        <Page.Title>
                            <FormattedMessage id={title} />
                        </Page.Title>
                        <Page.Subtitle>
                            <FormattedMessage id={subtitle} />
                        </Page.Subtitle>
                    </Page.HeaderLeft>
                    <Page.HeaderRight>
                        <SearchBar
                            customPlaceholder={'wms.cc.list.search.placeholder'}
                            onChange={(value) => setSearchString(value)}
                        />
                    </Page.HeaderRight>
                    <Page.Content>
                        <Tabs
                            value={selectedContainer}
                            indicatorColor="primary"
                            aria-label="translations"
                            TabIndicatorProps={{style: {background: blueColor}}}
                            variant="scrollable"
                            scrollButtons="auto"
                        >
                            <Tab
                                onClick={() => setSelectedContainer(null)}
                                label={<FormattedMessage id='wms.cc.list.tab.zone.all' />}
                                id={`simple-tab`}
                                value={null}
                                aria-controls={`simple-tabpanel-`}
                            />
                            {containers && containers.map((container, index) => (
                                <Tab
                                    onClick={() => setSelectedContainer(container.id)}
                                    key={index}
                                    label={container.name}
                                    value={container.id}
                                    id={`simple-tab`}
                                    aria-controls={`simple-tabpanel-`}
                                />
                            ))}
                        </Tabs>
                        <Table isDesktop={true}>
                            <TableHead>
                                <TableRowHead isDesktop={true}>
                                    {[
                                        {label: <FormattedMessage id='wms.cc.list.table.header.trackingNumber' /> },
                                        {label: <FormattedMessage id='wms.cc.list.table.header.name' /> , sortableCode: 'name'},
                                        {label: <FormattedMessage id='wms.cc.list.table.header.orderNumber' /> },
                                        {label: <FormattedMessage id='wms.cc.list.table.header.contact' /> },
                                        {label: <FormattedMessage id='wms.cc.list.table.header.date' /> , sortableCode: 'date'},
                                        {label: <FormattedMessage id='wms.cc.list.table.header.zone' /> , sortableCode: 'wmsContainer'},
                                        {label: <FormattedMessage id='wms.cc.list.table.header.action' /> }
                                    ].map((column, index) => (
                                        <TableCellHead
                                            key={index}
                                            sortable={!!column?.sortableCode}
                                            selectedOrderBy={sort.orderBy === column?.sortableCode}
                                            orderDirection={sort.orderBy === column?.sortableCode ? sort.orderDirection : 'asc'}
                                            onClick={() => handleRequestSort(column.sortableCode)}
                                        >
                                            {column.label}
                                        </TableCellHead>
                                    ))}
                                </TableRowHead>
                            </TableHead>
                            <TableBody>
                                {shipments.map((shipment) => (
                                    <TableRow key={shipment.id} isDesktop={true}>
                                        <TableCell>
                                            <TrackingNumber trackingNumber={shipment.externalDeliveryNumber} />
                                        </TableCell>
                                        <TableCell>
                                            <CustomerName
                                                lastName={shipment.order.customerShippingLastname}
                                                firstName={shipment.order.customerShippingFirstname}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            {shipment.order.displayExternalId}
                                        </TableCell>
                                        <TableCell>
                                            <CustomerContact
                                                email={shipment.order.customerShippingEmail}
                                                phone={shipment.order.customerShippingPhone}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <FormattedDate value={shipment.updatedAt} />
                                        </TableCell>
                                        <TableCell>
                                            <Containers shipment={shipment} />
                                        </TableCell>
                                        <TableCell>
                                            <ActionLink
                                                onClick={() => {
                                                    setSelectedShipment(shipment);
                                                    setOpenHandOverScanShipmentPopup(true);
                                                }}
                                            >
                                                <FormattedMessage id='wms.cc.handover.table.action' />
                                            </ActionLink>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <Pagination
                            handlePageChange={(page) => onPageChange(page)}
                            pageCount={totalPages}
                            onClickPrevious={() => getShipments(previousLink)}
                            onClickNext={() => getShipments(nextLink)}
                        />
                    </Page.Content>
                </Page>
            </WmsDesktopLayout.Content>
        </WmsDesktopLayout>
    );
}

export default DesktopView;
